export enum ComponentEnum {
    DatePicker,
    LocationPicker,
    CategoryPicker,
    NumberPicker,
    StringPicker,
    BooleanPicker,
    ImagePicker,
    SpecimenPicker,
    TaxonPicker,
    PersonPicker,
}